<template>
  <nav class="layout-footer bg-dark footer" :class="getLayoutFooterBg()">
    <div id="map" class="p-3" style="height:40vh;" v-show="isMapVisible">
      <customer-map @on-customer-select="onCustomerSelected"></customer-map>
    </div>
    <div class="container-fluid container-p-x pl-0 pb-3">
      <div class="row">
        <div class="col col-10">
          <a href="javascript:void(0)" @click="$router.push({name: 'customer-overview'})" class="footer-link pt-3"><i class="ion ion-md-people"></i> CUSTOMER</a>
          <a href="javascript:void(0)" @click="$router.push({name: 'books-overview'})" class="footer-link pt-3 ml-2"><i class="ion ion-md-book"></i> BOOKS</a>
          <a href="javascript:void(0)" @click="$router.push({name: 'offer-overview'})" class="footer-link pt-3 ml-2"><i class="ion ion-md-list"></i> OFFER</a>
          <a href="javascript:void(0)" @click="$router.push({name: 'po-overview'})"  class="footer-link pt-3 ml-2"><i class="ion ion-md-list"></i> PO</a>
          <a href="javascript:void(0)" @click="$router.push({name: 'invoice-overview'})" class="footer-link pt-3 ml-2"><i class="ion ion-md-document"></i> INVOICE</a>
          <a href="#" class="footer-link pt-3 ml-2"><i class="ion ion-md-trending-up"></i> STATS</a>

          <span class="ml-2">(Quick-Nav, für jeden individuell)</span>
        </div>
        <div class="col col-2 text-right">
          <a href="javascript:void(0);" @click="toggleMap()" class="footer-link pt-3 ml-4"><i class="ion ion-md-map"></i> <span v-bind:class="{ 'map-selected-customer': selectedCustomer }">{{mapToggleText}}</span></a>
        </div>
      </div>
      <!-- <a href="#" @click="toggleCollapsed()" class="footer-link pt-3"><i class="ion ion-md-book"></i> BOOKS</a> -->
    </div>
  </nav>
</template>

<script>
import CustomerMap from './../components/CustomerMap'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('customer')

export default {
    name: 'app-layout-footer',
    components: {
        'customer-map': CustomerMap
    },
    data: function () {
        return {
            isMapVisible: false
        }
    },
    methods: {
        getLayoutFooterBg () {
            return `bg-${this.layoutFooterBg}`
        },
        toggleMap () {
            this.isMapVisible = !this.isMapVisible
        },
        onCustomerSelected (customer) {
            this.isMapVisible = false
        }
    },
    computed: {
        mapToggleText () {
            if (this.isMapVisible) return 'CLOSE MAP'
            else if (this.selectedCustomer) return this.selectedCustomer.shortname
            else return 'OPEN MAP'
        },
        ...mapGetters([
            'selectedCustomer'
        ])
    }
}
</script>
<style>
</style>
